define('WineRingRec.Reccomendations.PDPButton.View', [
    'pdp_instant_recomendation_button.tpl',
    'Backbone'
], function WineRingRec(
    pdpInstantRecomendationButtonTpl,
    Backbone
) {
    return Backbone.View.extend({
        template: pdpInstantRecomendationButtonTpl
    });
});
